// extracted by mini-css-extract-plugin
module.exports = {"heroContent":"HeroContent_heroContent__2oYjL","mini":"HeroContent_mini__2APHt","fadeIn":"HeroContent_fadeIn__yE1tR"};